import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const FormResponseViewDialogLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-formresponseviewdialog" */ "./FormResponseViewDialog")).then((bundle)=>{
        return {
            default: bundle.FormResponseViewDialog
        };
    });
export const LazyFormResponseViewDialog = /*#__PURE__*/ lazy(FormResponseViewDialogLazyLoader);
